package org.solyton.solawi.bid.application.ui.page.user.`data`.filter

import kotlin.String
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [UserFilterQuery.username]
 */
@ReadWrite
public val username: Lens<UserFilterQuery, String?> by lazy {
      Lens(
        get = { whole -> whole.username },
        set = { part -> { whole -> whole.copy(username = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserFilterQuery.username]
 */
@ReadWrite
public fun UserFilterQuery.username(`set`: String?.() -> String?): UserFilterQuery = copy(username =
    set(username))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserFilterQuery.status]
 */
@ReadWrite
public val status: Lens<UserFilterQuery, String?> by lazy {
      Lens(
        get = { whole -> whole.status },
        set = { part -> { whole -> whole.copy(status = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserFilterQuery.status]
 */
@ReadWrite
public fun UserFilterQuery.status(`set`: String?.() -> String?): UserFilterQuery = copy(status =
    set(status))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserFilterQuery.firstName]
 */
@ReadWrite
public val firstName: Lens<UserFilterQuery, String?> by lazy {
      Lens(
        get = { whole -> whole.firstName },
        set = { part -> { whole -> whole.copy(firstName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserFilterQuery.firstName]
 */
@ReadWrite
public fun UserFilterQuery.firstName(`set`: String?.() -> String?): UserFilterQuery = copy(firstName
    = set(firstName))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserFilterQuery.lastName]
 */
@ReadWrite
public val lastName: Lens<UserFilterQuery, String?> by lazy {
      Lens(
        get = { whole -> whole.lastName },
        set = { part -> { whole -> whole.copy(lastName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserFilterQuery.lastName]
 */
@ReadWrite
public fun UserFilterQuery.lastName(`set`: String?.() -> String?): UserFilterQuery = copy(lastName =
    set(lastName))
